<template>
  <div class="p-about">
    <section class="c-p-r about-banner">
      <div class="c-d-f c-fd-c c-ai-c c-ta-c cm-width about-banner-desc">
        <p class="c-fs-38 c-c-text-color c-mb-32 c-fw-b top-title">关于我们</p>
        <p class="c-c-text-color c-fs-16 c-ff-l top-desc">智能运维解决方案提供商，您可信赖的运维专家</p>
      </div>
    </section>
    <section class="cm-width c-m-a company-introduce">
      <!-- <div class="c-visible-pc">
        <div class="c-d-f c-ai-c c-mt-80 c-mb-40" id="introduce">
          <img src="../assets/index/icon.png">
          <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">公司介绍</span>
        </div>
      </div>
      <div class="c-visible-mobile">
        <div class="c-d-f c-ai-c c-mt-28 c-mb-20" id="introduce-m">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">公司介绍</span>
        </div>
      </div> -->
      <div class="c-mt-80 c-fs-16 c-ta-j c-lh-32 c-pb-164 c-visible-pc" v-if="$store.state.isPc">
        <p class="c-ta-j">安徽高颐科技有限公司（简称“高颐科技”），您可信赖的IT智能运维解决方案提供商，专注于为客户提供IT智能运维产品、
          咨询及服务交付为一体的高新技术企业，目前公司拥有多项国家计算机软件著作权登记证书，通过了国际ISO9001质量体系认证，并与众多国际国内领先的技术供应商建立了广泛的业务合作关系，
          公司以产品、技术、服务为核心为广大用户解决运维的难题，提升IT运维效率，降低IT运维成本。</p>
        <div class="intro-wrap">
          <img src="../assets/about/team.jpg" class="intro-item-img"/>
          <div class="intro-item-text">
            <div class="c-d-f c-ai-c c-mb-12">
              <img src="../assets/index/icon.png">
              <p class="c-fs-24 c-ml-12 c-c-text-blue line">IT智能运维研究院</p>
            </div>
            <p class="c-mt-24">高颐科技的IT智能运维研究院成立于2009年，研究院团队成员汇聚了数十名行业专家，均有十余年的丰富的国内外运维软件的理论和项目管理经验，目前，
              研究院已经分布于安徽、广州、上海三地，以满足产品及服务的快速技术更新迭代及快速响应用户的业务需求。</p>
          </div>
        </div>
        <div class="intro-wrap">
          <div class="intro-item-text">
            <div class="c-d-f c-ai-c c-jc-fe c-mb-12 c-ta-r">
              <img src="../assets/index/icon.png">
              <p class="c-fs-24 c-ml-12 c-c-text-blue line">服务宗旨</p>
            </div>
            <p class="c-ta-j c-mt-24">高颐科技秉承以人为本的理念，培养了一支优秀的技术团队和服务力量。公司弘扬“承诺、创新、协作、共赢”的价值观，具有很强的企业凝聚力和向心力。
          一直以来，高颐科技潜心钻研行业客户需求，长期保持对创新的积极投入，并在业务实践中注重产品技术创新与行业业务应用的结合，为客户度身定制解决方案。
          通过运用业界丰富实践和先进技术，致力于实现客户的IT基础架构性能稳定，效率出众。帮助客户降低运营成本，快速应对市场变化，发挥竞争优势。</p>
          </div>
          <img src="../assets/about/service.jpg" class="intro-item-img"/>
        </div>
        <div class="intro-wrap">
          <img src="../assets/about/tech.jpg" class="intro-item-img"/>
          <div class="intro-item-text">
            <div class="c-d-f c-ai-c c-mb-12">
              <img src="../assets/index/icon.png">
              <p class="c-fs-24 c-ml-12 c-c-text-blue line">公司使命</p>
            </div>
            <p class="c-mt-24">高颐科技的优势不仅在于业界的领先技术和精锐的专业团队，还在于杰出的软硬件解决方案、卓越的服务能力和自主可控的软件研发能力，更在于积极创新的热情和尊重承诺的信念。
          成为客户可信赖的IT智能运维解决方案提供商，助力客户实现新IT的业务价值，是高颐科技始终不渝的使命和追求。</p>
          </div>
        </div>
      </div>
      <div class="c-mt-40 c-c-text-grey c-fs-12 c-ta-j c-pb-40 c-lh-22 c-visible-mobile" v-if="!$store.state.isPc">
        <p class="c-c-text-grey c-ta-j">安徽高颐科技有限公司（简称“高颐科技”），您可信赖的IT智能运维解决方案提供商，专注于为客户提供IT智能运维产品、
          咨询及服务交付为一体的高新技术企业，目前公司拥有多项国家计算机软件著作权登记证书，通过了国际ISO9001质量体系认证，并与众多国际国内领先的技术供应商建立了广泛的业务合作关系，
          公司以产品、技术、服务为核心为广大用户解决运维的难题，提升IT运维效率，降低IT运维成本。</p>
        <div class="c-d-f c-ai-c c-mt-24 c-mb-12">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <p class="c-fs-14 c-ml-8 c-c-text-blue">IT智能运维研究院</p>
        </div>
        <p class="c-mb-12">高颐科技的IT智能运维研究院成立于2009年，研究院团队成员汇聚了数十名行业专家，均有十余年的丰富的国内外运维软件的理论和项目管理经验，目前，
          研究院已经分布于安徽、广州、上海三地，以满足产品及服务的快速技术更新迭代及快速响应用户的业务需求。</p>
        <img src="../assets/about/team.jpg" style="width: 100%;">
        <div class="c-d-f c-ai-c c-mt-24 c-mb-12">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <p class="c-fs-14 c-ml-8 c-c-text-blue">服务宗旨</p>
        </div>
        <p class="c-mb-12">高颐科技秉承以人为本的理念，培养了一支优秀的技术团队和服务力量。公司弘扬“承诺、创新、协作、共赢”的价值观，具有很强的企业凝聚力和向心力。
          一直以来，高颐科技潜心钻研行业客户需求，长期保持对创新的积极投入，并在业务实践中注重产品技术创新与行业业务应用的结合，为客户度身定制解决方案。
          通过运用业界丰富实践和先进技术，致力于实现客户的IT基础架构性能稳定，效率出众。帮助客户降低运营成本，快速应对市场变化，发挥竞争优势。</p>
        <img src="../assets/about/service.jpg" style="width: 100%;">
        <div class="c-d-f c-ai-c c-mt-24 c-mb-12">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <p class="c-fs-14 c-ml-8 c-c-text-blue">公司使命</p>
        </div>
        <p class="c-mb-12">高颐科技的优势不仅在于业界的领先技术和精锐的专业团队，还在于杰出的软硬件解决方案、卓越的服务能力和自主可控的软件研发能力，更在于积极创新的热情和尊重承诺的信念。
          成为客户可信赖的IT智能运维解决方案提供商，助力客户实现新IT的业务价值，是高颐科技始终不渝的使命和追求。</p>
        <img src="../assets/about/tech.jpg" style="width: 100%;">
      </div>
    </section>
    <!-- <section class="cm-width c-m-a honor-wrap">
      <div class="c-visible-pc">
        <div class="c-d-f c-ai-c c-mt-80 c-mb-40" id="honor">
          <img src="../assets/index/icon.png">
          <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">荣誉资质</span>
        </div>
      </div>
      <div class="c-visible-mobile">
        <div class="c-d-f c-ai-c c-mt-40 c-mb-24" id="honor-m">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">荣誉资质</span>
        </div>
      </div>
      <div class="c-visible-pc">
        <div class="c-d-f c-jc-sb">
          <img class="c-bc-white c-cs-p honor-item" src="../assets/training/certificate1.jpg" preview="honor-pc"/>
          <img class="c-bc-white c-cs-p honor-item" src="../assets/training/certificate1.jpg" preview="honor-pc"/>
          <img class="c-bc-white c-cs-p honor-item" src="../assets/training/certificate1.jpg" preview="honor-pc"/>
        </div>
      </div>
      <div class="c-visible-mobile">
        <div class="c-d-f c-jc-sb">
          <img class="c-bc-white honor-item" src="../assets/training/certificate1.jpg" preview="hornor-mobile"/>
          <img class="c-bc-white honor-item" src="../assets/training/certificate1.jpg" preview="hornor-mobile"/>
          <img class="c-bc-white honor-item" src="../assets/training/certificate1.jpg" preview="hornor-mobile"/>
        </div>
      </div>
    </section>
    <section class="c-visible-pc">
      <section class="cm-width c-m-a c-pb-164 contact-wrap" id="contact">
        <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
          <img src="../assets/index/icon.png">
          <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">联系我们</span>
        </div>
        <div class="c-d-f">
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-b-r c-pt-24">
            <div class="cm-w-60">
              <img src="../assets/about/about1.png">
              <p class="c-fs-20 c-mt-32 c-c-text-blue">邮箱</p>
              <p class="c-mt-16 c-fs-14 c-lh-22 c-ta-c c-c-text-grey">joshua#quaee.com</p>
            </div>
          </div>
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-b-r c-pt-24">
            <div class="cm-w-60">
              <img src="../assets/about/about2.png">
              <p class="c-fs-20 c-mt-32 c-c-text-blue">电话</p>
              <p class="c-mt-16 c-fs-14 c-lh-22 c-ta-c c-c-text-grey">4006-111-696</p>
            </div>
          </div>
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-pt-24">
            <div class="cm-w-60">
              <img src="../assets/about/about3.png">
              <p class="c-fs-20 c-mt-32 c-c-text-blue">地址</p>
              <p class="c-mt-16 c-fs-14 c-lh-22 c-ta-c c-c-text-grey">安徽省池州经济技术开发区电子信息产业园7楼</p>
            </div>
          </div>
        </div>
      </section>
    </section>
    <section class="c-visible-mobile">
      <section class="cm-width c-m-a c-pb-40 contact-wrap-mobile" id="contact-m">
        <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">联系我们</span>
        </div>
        <div class="c-d-f c-ai-c c-bc-white c-mb-8 c-p-24">
          <img src="../assets/about/about1.png" class="contact-img">
          <div class="c-ml-28">
            <p class="c-fs-15 c-c-text-blue">邮箱</p>
            <p class="c-mt-12 c-fs-12 c-lh-18 c-ta-c c-c-text-grey">joshua#quaee.com</p>
          </div>
        </div>
        <div class="c-d-f c-ai-c c-bc-white c-mb-8 c-p-24">
          <img src="../assets/about/about2.png" class="contact-img">
          <div class="c-ml-28">
            <p class="c-fs-15 c-c-text-blue">电话</p>
            <p class="c-mt-12 c-fs-12 c-lh-18 c-ta-c c-c-text-grey">4006-111-696</p>
          </div>
        </div>
        <div class="c-d-f c-ai-c c-bc-white c-mb-8 c-p-24">
          <img src="../assets/about/about3.png" class="contact-img">
          <div class="c-ml-28">
            <p class="c-fs-15 c-c-text-blue">地址</p>
            <p class="c-mt-12 c-fs-12 c-lh-18 c-c-text-grey">安徽省池州经济技术开发区电子信息产业园7楼</p>
          </div>
        </div>
      </section>
    </section> -->
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.p-about {
  min-height: calc(100vh - 90px - 525px);
  .cm-w-60 {
    width: 60%;
  }
  .about-banner {
    height: 560px;
    background: url("../assets/about/about-banner.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      background: url("../assets/about/about-banner-m.jpg") no-repeat center / cover;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px!important;
      }
    }
    .about-banner-desc {
      position: absolute;
      top: 32%;
      left: 50%;
      @media screen and (max-width: $max-width-standard) {
        top: 26%;
        left: 50%;
      }
      transform: translateX(-50%);
    }
  }
  .news-wrap {
    .news-content {
      .news-item {
        margin-left: 20px;
        border-bottom: 4px solid #44DBE7;
        &:hover {
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
        }
        .news-img {
          height: 314px;
          background: $background-blue;
        }
        .news-item-bottom {
          min-height: 340px;
          padding-left: 22px;
          padding-right: 22px;
          .news-item-top {
            min-height: 80px;
          }
        }
      }
      & .news-item:nth-of-type(1) {
        margin-left: 0;
      }
      & .news-item:nth-of-type(2) {
        border-bottom-color: $orange;
      }
      & .news-item:nth-of-type(3) {
        border-bottom-color: #4FC4FF;;
      }
      & .news-item:nth-of-type(4) {
        border-bottom-color: #FFE653;;
      }
    }
  }
  .news-wrap-mobile {
    .news-content {
      .news-item {
        width: calc(50% - 4px);
        border-bottom: 3px solid #44DBE7;
        &:hover {
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
        }
        .news-img {
          height: 106px;
          background: $background-blue;
        }
        .news-item-bottom {
          padding-left: 16px;
          padding-right: 16px;
          padding-bottom: 16px;
          .news-item-top {
            height: 36px;
            overflow: scroll;
          }
        }
      }
      & .news-item:nth-of-type(1) {
        margin-left: 0;
      }
      & .news-item:nth-of-type(2) {
        border-bottom-color: $orange;
      }
      & .news-item:nth-of-type(3) {
        border-bottom-color: #4FC4FF;;
      }
      & .news-item:nth-of-type(4) {
        border-bottom-color: #FFE653;;
      }
    }
  }
  .honor-wrap {
    .honor-item {
      height: 283px;
      width: calc(100% / 3 - 12px);
      @media screen and (max-width: $max-width-standard) {
        height: 80px;
        width: calc(100% / 3 - 6px);
      }
      box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
    }
  }
  .company-introduce {
    .intro-wrap {
      display: flex;
      justify-content: space-between;
      margin-top: 70px;
      .intro-item-text {
        width: 40%;
      }
      .intro-item-img {
        width: 56%;
        height: 360px;
        object-fit: cover;
      }
      // .line {
      //   border-bottom: 2px solid $text-blue;
      // }
    }
  }
  .contact-wrap-mobile {
    .contact-img {
      width: 62px;
      height: 62px;
    }
  }
}
</style>
